import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/crmCustomerAccount/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/crmCustomerAccount',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/crmCustomerAccount',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/crmCustomerAccount/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/crmCustomerAccount',
    method: 'get',
    params: {
      id
    }
  })
}
